<template>
    <div class="view-tracks">
        <div class="input-card" style="position: fixed ;">
            <!-- <h4>轨迹回放控制</h4> -->
            <div class="input-item">
                <input type="button" class="btn1" value="开始动画" id="start" @click="startAnimation"/>
                <input type="button" class="btn2" value="暂停动画" id="pause" @click="pauseAnimation"/>
            </div>
            <div class="input-item">
                <input type="button" class="btn3" value="继续动画" id="resume" @click="resumeAnimation"/>
                <input type="button" class="btn4" value="停止动画" id="stop" @click="stopAnimation"/>
            </div>
            <div class="address">  
                <el-input v-model="addressData"></el-input>
            </div>
            <div class="TimeStyle">
                <el-date-picker
                    v-model="Dform.startTime"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="YYYY-MM-DD HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    @change="pickerChangeFn"
                    >
                    </el-date-picker>
            <div class="queryStyle">
                <el-button @click="queryClick" type="primary">查询</el-button>

            </div>
            </div>
        </div>
 
        <div class="map-container" >
            <Mapview 
            :deviceLocationDetails="deviceLocationDetails" 
            :status="status" 
            :statusCartoon="statusCartoon" 
            :SlistData="SlistData"
            :listDatazuobiao="listDatazuobiao"
            @statusCartoonClick="statusCartoonClick"
            ></Mapview>
        </div>

    </div>
</template>

<script>
// import Header from '@/views/cust-match-results/header/index.vue'
import Mapview from "@/components/MapContainer.vue"
import {deviceFindGuiji} from '@/assets/api/user'


export default {
    components: {
        Mapview
    },
    data() {
        return {
            status: null,
            statusCartoon: '',
            listDatazuobiao: [],
            SlistData: [],
            Dform:{
                // startTime:[]
                startTime: [],
            },
            addressData:'',
            startStr:'',
            endstr:'',
        };
    },
    created() {
        this.status = 3
        this.timeshow()
        window.document.title = '轨迹查询'        
    },
    mounted() {
        // history.state.deviceName
        this.searcherShow()


        // console.log(history.state,'查询1111111');
    },
    activated() {  

    },

    methods: {
        timeshow(){
         const date = new Date()
         const year = date.getFullYear()
         const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
         const day = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
         const hours = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()
         const minutes = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes()
        const seconds = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds()
         let TimeStr= `${year}${'-'}${month}${'-'}${day} 00:00:00`
         let endTime = `${year}${'-'}${month}${'-'}${day} ${hours}:${minutes}:${seconds}`

        this.startStr = TimeStr.toString()
        this.endstr = endTime.toString()
         console.log( this.endstr,this.startStr,'11111111111111111111111111');
        },
        pickerChangeFn () {
            console.log(55555,this.Dform.startTime);
        },
        queryClick(){
            console.log('我是查询',this.Dform.startTime);
            this.searcherShow()
        },
        searcherShow(){
        // console.log(1);
       
        const params = {
            // imei:'860995060403623',
            // endTime:'2024-03-15 23:59:59',
            // startTime:'2024-03-15 00:00:00',
            imei:this.$route.query.iemi,
            startTime:this.Dform.startTime!= ''?this.Dform.startTime[0]:this.startStr,
            endTime:this.Dform.startTime!= ''?this.Dform.startTime[1]:this.endstr,

        }
        deviceFindGuiji(params).then((res)=>{
            console.log(res,'轨迹查询1');
            if ( !res.data.data.length ) {
                this.$message.error('暂无数据');
            }
            this.SlistData = res.data.data
            let list = []
            res.data.data.forEach((item,index)=> {
                list.push([item.lng1,item.lat1])
            })
            this.listDatazuobiao = list
            console.log(this.listDatazuobiao,7777);
          
        }).catch((err)=> {
            console.log(err ,'轨迹 查询失败');
        })
        },
        startAnimation () {
            // marker.moveAlong(lineArr, 200);
            this.statusCartoon = '开始动画'
        },

        pauseAnimation () {
            // marker.pauseMove();
            this.statusCartoon = '暂停动画'
        },

        resumeAnimation () {
            // marker.resumeMove();
            this.statusCartoon = '继续动画'
        },
        stopAnimation(){
            // marker.stopMove();
            this.statusCartoon = '停止动画'
        },
        statusCartoonClick(value) {
            // this.statusCartoon = ''
            this.addressData = value
            console.log(this.addressData,'****************');
        }
    }
};
</script>

<style scoped lang="scss">
.view-tracks {
    width: 100%;
    height: 100vh;
    background-color: #fff;
    padding: 30px;
    position: absolute;
    .map-container{
    
            height:100%;
            width: 100%;
    }
    .input-card {
        z-index: 999;
        .btn1{
            height: 50px;
            background-color: skyblue;
            margin-right: 1.2rem;
            width: 9rem;
            color: #fff;
            cursor: pointer;
            border-radius: 20px;
        }
        .btn2{
            height: 50px;
            background-color: skyblue;
            margin-right: 1.2rem;
            width: 9rem;
            color: #fff;
            cursor: pointer;
            border-radius: 20px;

        }
        .btn3{
            height: 50px;
            background-color: skyblue;
            margin-right: 1.2rem;
            width: 9rem;
            color: #fff;
            margin-top: 10px;
            cursor: pointer;
            border-radius: 20px;

        }
        .btn4{
            height: 50px;
            background-color: skyblue;
            margin-right: 1.2rem;
            width: 9rem;
            color: #fff;
            margin-top: 10px;
            cursor: pointer;
            border-radius: 20px;

        }
    }

    .input-card .btn:last-child{
            margin-right: 0;
        }
    .TimeStyle{
        margin-left: 5px;
        margin-top: 20px;
        /deep/{
            .el-range-editor--small.el-input__wrapper{
                height: 35px;
                width: 100%;
            }

        }
        .queryStyle{
            padding-left: 300px;
            padding-top: 20px;
            /deep/ .el-button--small {
                height: 30px;
                width: 50px;
                background-color: skyblue;
            }
        }
        }
    .address{
        margin-left: 5px;
        margin-top: 20px;
        /deep/{
            .el-input--small .el-input__inner{
                height: 32px;
                width: 90px !important;
            }
        }

    }
}
</style>
